


























































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import { RegisterInfo } from "../user/UserApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class TtczzfHome extends mixins(WeMixin) {
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private isError: boolean = true;
  private isShowError: boolean = false;

  private rTime: number = 0;

  protected created() {
    this.checkIsSubscribe();
  }

  protected checkIsSubscribe() {
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.isError = false;
        this.isShowError = true;
      } else {
        this.getCustomerInfo();
      }
    });
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        window.location.href =
          process.env.VUE_APP_498_URL +
          encodeURIComponent(
            process.env.VUE_APP_URLFRONT + "/main/ttczzf/ttczzfRaffle"
          );
      } else if (res.data.flag === "1") {
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace("/main/user/registerFromTtczzf");
          }
        }, 2000);
      }
    });
  }

  protected toRegister() {
    this.$router.replace("/main/user/registerFromTtczzf");
  }

  protected toRaffle() {
    this.$router.go(0);
  }
}
